import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

/**
 * NotFound component
 * Displayed when a user navigates to a non-existent route
 * Supports multiple languages through i18n
 */
const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('notFound.title')}</title>
        <meta name="description" content={t('notFound.description')} />
      </Helmet>
      
      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <h1 className="text-6xl font-bold text-primary mb-6">{t('notFound.heading')}</h1>
          <h2 className="text-2xl font-bold mb-4">{t('notFound.subheading')}</h2>
          <p className="text-gray-600 mb-8">
            {t('notFound.message')}
          </p>
          <Link 
            to="/" 
            className="btn bg-primary hover:bg-secondary text-white font-semibold py-3 px-8 rounded-md transition-all duration-300 hover:-translate-y-1 inline-flex items-center"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            {t('notFound.backToHome')}
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
